module.exports = __webpack_public_path__ + "14bde86cc0f9d860cc256cfc005c80b8.svg";